/** API URL STARTS*/

const HOST_URL = process.env.REACT_APP_API_HOST_URL;
export const REST_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_ROOT = `${HOST_URL}/fom`;
export const USER_API_URL = `${process.env.REACT_APP_API_ENDPOINT}/user`;

/** API URL ENDS*/

/** Route Constants start */

/** Route app login/callback routes */
export const ROUTE_APP_HOME = "/home";
export const ROUTE_OKTA_CALLBACK = "/login/callback";
export const ROUTE_FOM = "/";

/** Route app internal user routes */
export const ROUTE_FOM_MANAGE_ORDERS = "/order-management/manage-orders";
export const ROUTE_FOM_PROVIDER = "/project-setup/provider";
export const ROUTE_FOM_COST = "/project-setup/cost";
export const ROUTE_FOM_RESET_ORDERS = "/order-management/reset-error-orders";
export const ROUTE_FOM_MANAGE_QUOTE_ORDERS = "/order-management/manage-quotes/orders";
export const ROUTE_FOM_ORDER_ADJUSTMENT = "/order-management/control-tower";
export const ROUTE_FOM_MANAGE_QUOTE_SUBMITTED_ORDERS = "/order-management/manage-quotes/submitted-quotes";
export const ROUTE_FOM_MANAGE_QUOTE_RESULTS = "/order-management/manage-quotes/quote-results";

/** Route app forwarder user routes */
export const ROUTE_FOM_FORWARDER_LOAD_BUILD = "/forwarder/load-build";
export const ROUTE_FOM_FORWARDER_AVIS = "/forwarder/avis";
export const ROUTE_FOM_FORWARDER_ALL_ORDERS = "/forwarder/all-orders";
export const ROUTE_FOM_FORWARDER_QUOTE_ORDERS = "/forwarder/quoting/forwarder-orders";
export const ROUTE_FOM_FORWARDER_SUBMITTED_QUOTE_ORDERS = "/forwarder/quoting/forwarder-submitted-orders";
export const ROUTE_FOM_FORWARDER_QUOTE_RESULTS_ORDERS = "/forwarder/quoting/forwarder-quote-results";

/** Route app factory user routes */
export const ROUTE_FOM_FACTORY_LOAD_SCHEDULE = "/factory/load-schedule";

/** Route app error routes */
export const ROUTE_FOM_INTERNAL_SERVER_ERROR = "internal-server-error";
export const ROUTE_AUTH_ERROR = "/authError";

/** Route compliance routes */
export const ROUTE_FOM_COMPLIANCE_AUDIT = "/compliance/audit";

/** Route Reports */
export const ROUTE_FOM_REPORTS = "/reports";

/** Route Constants end */

/** OKTA CONSTANTS START */

const OKTA_REDIRECT_URI = `${window.location.origin}${ROUTE_OKTA_CALLBACK}`;

export const OKTA_CONFIG = {
  clientId: process.env.REACT_APP_OKTA_CLIENT,
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  pkce: true,
  redirectUri: OKTA_REDIRECT_URI,
  scopes: process.env.REACT_APP_OKTA_SCOPES.split(' '),
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
  },
};

export const OKTA_STORAGE_TOKEN = "okta-token-storage";

/** OKTA CONSTANTS ENDS */

/** URGENT ACTION TOOLTIPS START */
export const URGENT_ACTION_TOOLTIPS = {
  MISSING_SHIPPING_ORDER: "Order is overdue for pickup but has no load build created",
  LATE_PICKUP: "Order has loadbuild but has an overdue departure date from point of pickup",
  DELIVERY_DATE_MISSING: "Order is departed and has an overdue delivery",
  VAT_DECLARATION_MISSING: "Order has arrived but VAT compliance is pending"
};

/** URGENT ACTION TOOLTIPS END */
